import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import CreatePlanGroupApi from "../../../api/CreatePlanGroupApi";
import { GetActiveScalesApi } from "../../../api/GetActiveScalesApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

const { TextArea } = Input;

function AddPlanGroupModal(props) {
  const [submit, setSubmit] = useState(false);
  const [scales, setScales] = useState();
  const [form] = Form.useForm();

  function handleCancel() {
    setSubmit(false);
    setScales();
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getScales();
    }
  }, [props.visible]);

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreatePlanGroupApi(
      values.name,
      values.description,
      values.scale || getNumber()
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Plan group added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add plan group. Try again later."
      );
    }
    handleCancel();
  }

  function getNumber() {
    let output = "";
    scales.forEach((scale) => {
      if (scale.name === "Number") {
        output = scale.id;
      }
    });
    return output;
  }

  async function getScales() {
    const apiResponse = await GetActiveScalesApi();
    if (apiResponse.success) {
      setScales(apiResponse.data);
      apiResponse.data.forEach((scale) => {
        if (scale.name === "Number" && scale.default) {
          form.setFields([
            {
              name: "scale",
              value: scale.id,
            },
          ]);
        }
      });
    }
  }

  return (
    <Modal
      title="Add plan group"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="planGroup"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <Form.Item
          label="Group name*"
          name="name"
          rules={[{ required: true, message: "Please enter a group name!" }]}
        >
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <TextArea showCount maxLength={100} placeholder="Description" />
        </Form.Item>

        <Form.Item label="Default scale" name="scale">
          <Select
            allowClear
            showSearch
            placeholder="Select scale"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {scales?.map((typ) => {
              return (
                <Option key={typ.id} value={typ.id}>
                  {typ.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPlanGroupModal;
